"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.Typography = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _nucleusTestAutomation = require("@cvent/nucleus-test-automation");
var _is = require("../../../utils/is");
var _cssFor = require("../../../utils/css/cssFor");
var _useTheme = require("../../ThemeProvider/useTheme");
var _typography = require("..");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var useStyle = function(param) {
    var typographyStyles = param.typographyStyles, styledAs = param.styledAs, typeStyle = param.typeStyle, css = param.css;
    var ref;
    var theme = (0, _useTheme).useTheme();
    return _objectSpread({}, styledAs && (typographyStyles === null || typographyStyles === void 0 ? void 0 : (ref = typographyStyles.base) === null || ref === void 0 ? void 0 : ref[styledAs]), typeStyle && (0, _is).isObject(typeStyle) && (0, _cssFor).typography(typeStyle, theme), css);
};
var Typography = (0, _react).forwardRef(function(_param, ref) {
    var tmp = _param.as, element = tmp === void 0 ? 'div' : tmp, typeStyle = _param.typeStyle, cssProp = _param.css, styledAsProp = _param.styledAs, testID = _param.testID, props = _objectWithoutProperties(_param, [
        "as",
        "typeStyle",
        "css",
        "styledAs",
        "testID"
    ]);
    var Element = element;
    var typographyStyles = (0, _typography).useTypography();
    var styledAs = typeof typeStyle === 'string' ? typeStyle : styledAsProp;
    var css = useStyle({
        typographyStyles: typographyStyles,
        styledAs: styledAs,
        typeStyle: typeStyle,
        css: cssProp
    });
    return (0, _jsxRuntime).jsx(Element, _objectSpread({
        css: css
    }, props, {
        ref: ref
    }, (0, _nucleusTestAutomation).injectTestId(testID)));
});
exports.Typography = Typography;
var _default = Typography;
exports.default = _default;
